import './lamay/style';
import FormStructure from './lamay/form_structure';

export default FormStructure;